import type { AvailabilitySlot } from '../../../../types/therapist-dashboard.types';

// Days of week configuration
export const DAYS_OF_WEEK = [
  { value: 0 as const, label: 'Sunday', short: 'Sun' },
  { value: 1 as const, label: 'Monday', short: 'Mon' },
  { value: 2 as const, label: 'Tuesday', short: 'Tue' },
  { value: 3 as const, label: 'Wednesday', short: 'Wed' },
  { value: 4 as const, label: 'Thursday', short: 'Thu' },
  { value: 5 as const, label: 'Friday', short: 'Fri' },
  { value: 6 as const, label: 'Saturday', short: 'Sat' },
];

export type DayOfWeekConfig = (typeof DAYS_OF_WEEK)[number];

// Time options for dropdowns (30-minute intervals)
export const TIME_OPTIONS = Array.from({ length: 48 }, (_, i) => {
  const hours = Math.floor(i / 2);
  const minutes = (i % 2) * 30;
  const time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  const period = hours < 12 ? 'AM' : 'PM';
  const display = `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
  return { value: time, label: display };
});

// Default slot template
export const createDefaultSlot = (
  therapistId: string,
  dayOfWeek: 0 | 1 | 2 | 3 | 4 | 5 | 6
): AvailabilitySlot => ({
  id: `temp-${dayOfWeek}`,
  therapistId,
  dayOfWeek,
  startTime: '09:00',
  endTime: '17:00',
  isAvailable: false,
  recurring: true,
});
